/**
 * Where a "tell me about the full platform" request goes on the Nexoya tenant.
 *
 * A mailto, not a booking link: no backend mutation exists for "register plan interest" and
 * none is being added, so the honest affordance is an email the analyst can see, edit and
 * send. `interestMailto.ts` builds the href; this is only the address.
 *
 * White-label tenants never use this — they get their own `customization.supportMail`, and
 * this value is the last-resort fallback only because `customization` initialises to `{}`
 * (`src/store/organization.ts:32`) and `DEFAULT_UI_CUSTOMIZATION_FALLBACK` is applied by
 * `queryTeam.ts`, not by the store.
 */
export const NEXOYA_CONTACT_EMAIL = 'support@nexoya.io';

/**
 * Where "Book a demo" goes on the Nexoya tenant. A real destination, so the CTA is an anchor
 * rather than a button firing navigation — it opens in a new tab so the analyst keeps the
 * portfolio they were looking at. White-label tenants never reach this: sending an agency's
 * own client to the vendor's site would leak exactly what the white-label branch hides.
 */
export const NEXOYA_DEMO_URL = 'https://nexoya.com/demo';
